const PersonStoreTypes = {
	Get: {
		LIST_OF_PEOPLE: 'getListOfPeople' ,
		LIST_OF_CRITERIA: 'getCriteria',
		LIST_OF_PEOPLE_WITH_CANCEL_TOKEN: 'getListOfPeopleWithCancelToken'
	} ,
	Set: {
		DELETE_PEOPLE: 'deletePeople' ,
	}
};

export default PersonStoreTypes;